<div class="wrapper" appMousemove>
  <app-scroll-to-top-btn></app-scroll-to-top-btn>
  <app-navigation></app-navigation>

  <router-outlet></router-outlet>

  <app-footer></app-footer>
</div>
